import type { FetchByQueryResult, Segment } from "mobx-repository";
import { prop } from "ramda";
import type {
    FleetAuthenticateEventsApi,
    FleetAuthenticateEventsListFleetAuthenticatePeriodsRequest,
    FleetAuthenticatePeriod,
    FleetAuthenticatePeriodSortKey,
    PageInfo,
} from "../../api";
import type { ApiResource } from "../../utils/elofleet-repository";
import { ElofleetRepository } from "../../utils/elofleet-repository";

export type FleetAuthenticatePeriodQuery = Omit<
    FleetAuthenticateEventsListFleetAuthenticatePeriodsRequest,
    "page"
>;

export interface FleetAuthenticatePeriodApiResource extends ApiResource {
    entity: FleetAuthenticatePeriod;
    query: FleetAuthenticatePeriodQuery;
    update: unknown;
    create: unknown;
    sortKey: FleetAuthenticatePeriodSortKey;
}

export class RepositoryFleetAuthenticatePeriods extends ElofleetRepository<FleetAuthenticatePeriodApiResource> {
    constructor(private readonly fleetAuthenticateEventsApi: FleetAuthenticateEventsApi) {
        super();
    }

    protected extractId = prop("id");

    protected async fetchByQuery(
        query: FleetAuthenticatePeriodQuery,
        pagination: Segment,
    ): Promise<FetchByQueryResult<FleetAuthenticatePeriod>> {
        const page = pagination.offset / this.defaultCount;
        const entities =
            await this.fleetAuthenticateEventsApi.fleetAuthenticateEventsListFleetAuthenticatePeriods(
                {
                    ...query,
                    page,
                },
            );
        return { entities };
    }

    public fetchMetadata(query: FleetAuthenticatePeriodQuery): Promise<PageInfo> {
        return this.fleetAuthenticateEventsApi.fleetAuthenticateEventsListFleetAuthenticatePeriodsMetadata(
            query,
        );
    }

    public create(_create: never): Promise<FleetAuthenticatePeriod> {
        throw new Error("Cannot create new fleet authenticate period: Method not implemented.");
    }
    public update(_update: never): Promise<FleetAuthenticatePeriod> {
        throw new Error("Cannot update new fleet authenticate period: Method not implemented.");
    }
    public delete(..._ids: string[]): Promise<void> {
        throw new Error("Cannot delete fleet authenticate period: Method not implemented.");
    }
    protected fetchById(_id: string): Promise<FleetAuthenticatePeriod | undefined> {
        throw new Error("Cannot fetch fleet authenticate period by ID: Method not implemented.");
    }
}
